import React, { useEffect } from 'react';

const CriteoHomeTag = () => {
  useEffect(() => {
    if (typeof window !== undefined) {
      window.criteo_q = window.criteo_q || [];
      const deviceType = /iPad/.test(navigator.userAgent)
        ? 't'
        : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
        ? 'm'
        : 'd';
      window.criteo_q.push(
        { event: 'setAccount', account: 76310 },
        { event: 'setSiteType', type: deviceType },
        { event: 'viewHome' }
      );
    }
  }, []);

  return <></>;
};

export default CriteoHomeTag;
